module.exports = __webpack_public_path__ + "img/qualifications.dba1ad9a.svg";